import styled from "styled-components";

export const Container = styled.div`
  @media (min-width: 768px) {
    margin-top: 41px;
  }

  .options {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 20px;

    @media (min-width: 768px) {
      shape-outside: ellipse(20px 20px at 50% 50%);
      float: left;
    }

    > svg {
      margin-right: 25px;
    }
  }
`;

export const WishlistInformationsCard = styled.div`
  padding: 12px 16px;
  border-radius: 16px;
  background-color: ${(props) => props.theme.colors.brand4.medium};
  margin-bottom: 16px;

  .loadingInfo {
    font-weight: 550;
    font-size: 1.6rem;
    color: ${(props) => props.theme.colors.typography1.pure};

    @media (min-width: 480px) {
      font-size: 2rem;
      line-height: 40px;
    }

    @media (min-width: 768px) {
      font-size: 1rem;
      line-height: 20px;
    }
  }

  @media (min-width: 480px) {
    padding: 32px 24px;
    margin-bottom: 24px;
  }

  @media (min-width: 768px) {
    padding: 16px 12px;
    margin-bottom: 16px;
  }
`;

export const WishlistInformationsCardNameContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
`;

export const CardNameLeft = styled.div`
  > span {
    font-size: 0.75rem;
    color: #ededed;
  }

  > div {
    display: flex;
    align-items: center;
  }

  > div > svg {
    height: 18px;
    width: 18px;
    margin-right: 8px;
  }

  > div > h4 {
    font-weight: 550;
    font-size: 1.3rem;
    color: ${(props) => props.theme.colors.typography1.pure};
  }

  @media (min-width: 480px) {
    > span {
      font-size: 1rem;
    }

    > div > svg {
      height: 32px;
      width: 32px;
    }

    > div > h4 {
      font-size: 2rem;
      line-height: 40px;
    }
  }

  @media (min-width: 768px) {
    > span {
      font-size: 0.6rem;
    }

    > div > svg {
      height: 16px;
      width: 16px;
      margin-right: 4px;
    }

    > div > h4 {
      font-size: 1rem;
      line-height: 20px;
    }
  }
`;
export const CardNameRight = styled.button`
  display: flex;
  align-items: center;
  background-color: transparent;
  border: none;

  :active {
    transform: translateY(4px);
  }

  > svg {
    height: 16px;
    width: 16px;
    margin-right: 8px;

    @media (min-width: 480px) {
      height: 24px;
      width: 24px;
    }

    @media (min-width: 768px) {
      height: 12px;
      width: 12px;
      margin-right: 4px;
    }
  }

  > p {
    font-size: 1rem;
    color: #dbc7b8;

    @media (min-width: 768px) {
      font-size: 0.7rem;
      line-height: 20px;
    }
  }
`;

export const WishlistInformationsCardItems = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  @media (min-width: 768px) {
    gap: 12px;
  }
`;

export const WishlistInformationsSettings = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 0 10px;

  @media (min-width: 768px) {
    display: grid;
    gap: 16px;
    grid-template-columns: repeat(1, 1fr);
  }

  .edit__desktop {
    @media (min-width: 768px) {
      display: none;
    }
  }

  > button {
    padding: 12px 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    background-color: transparent;
    border-radius: 16px;
    border: none;
    font-weight: 550;
    font-size: 0.8rem;
    text-transform: uppercase;

    @media (min-width: 480px) {
      height: 80px;
      font-size: 1.5rem;
      line-height: 30px;
    }

    @media (min-width: 768px) {
      height: 35px;
      font-size: 0.75rem;
      line-height: 15px;
    }

    :disabled {
      cursor: not-allowed;
    }

    > svg {
      width: 20px;
      height: 20px;
      margin-right: 6px;

      @media (min-width: 480px) {
        width: 32px;
        height: 32px;
      }

      @media (min-width: 768px) {
        width: 16px;
        height: 16px;
      }
    }
  }

  .btn__edit {
    border: 1px solid ${(props) => props.theme.colors.brand1.pure};
    color: ${(props) => props.theme.colors.brand1.pure};
  }

  .btn__delete {
    border: 1px solid ${(props) => props.theme.colors.error.pure};
    color: ${(props) => props.theme.colors.error.pure};
  }

  .edit {
    display: inline-flex;

    @media (min-width: 768px) {
      display: none;
    }
  }
`;
